import PropTypes from 'prop-types';

import Collapse from 'shopper/components/Collapse';
import Text from 'shopper/components/Text';

const FrequentAskedQuestions = ({ faqs }) => (
  <div className="flex flex-1 flex-col gap-4">
    {faqs.map(({ question, answer }) => (
      <Collapse key={question} title={question}>
        <Text>{answer}</Text>
      </Collapse>
    ))}
  </div>
);

FrequentAskedQuestions.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default FrequentAskedQuestions;
